<template>
  <div class="mb-3">
    <div
      class="d-flex align-items-center"
      :class="{ 'mb-3': searchable || filterable }"
    >
      <slot name="beforeSearch" />
      <b-form-group v-if="searchable" class="mb-0" label-for="filter">
        <b-input-group class="input-group-labeled">
          <b-form-input
            v-model="searchVal"
            class="pr-0"
            placeholder="Vyhľadať..."
            @keydown.enter="search"
          />
          <b-input-group-append>
            <b-btn variant="link" class="px-2" @click="search">
              <b-icon icon="search" />
            </b-btn>
            <b-btn v-if="searchVal" variant="link" class="px-2" @click="reset">
              <b-icon icon="x-circle" />
            </b-btn>
            <b-btn
              v-if="filterable"
              v-b-toggle.toggleFilter
              v-b-tooltip.hover.bottom
              class="p-1"
              :variant="showFilter ? 'primary' : 'link'"
              title="Filter"
            >
              <b-icon icon="filter" />
              <b-icon :icon="`arrow-${showFilter ? 'up' : 'down'}-short`" />
            </b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <slot name="afterSearch" />
    </div>
    <b-collapse
      id="toggleFilter"
      @show="showFilter = true"
      @hide="showFilter = false"
    >
      <div class="bg-white pt-2 px-3">
        <slot name="filter" />
      </div>
    </b-collapse>
    <div class="table-container" :class="{ loading: isBusy }">
      <b-table
        ref="table"
        :busy.sync="isBusy"
        :class="tableClass"
        :fields="columns"
        :items="data"
        :current-page="currentPage"
        :per-page="perPage"
        :sort-desc="sortDesc"
        class="bg-white"
        show-empty
        :empty-text="
          isBusy ? 'Načítavanie...' : 'Neboli nájdené žiadne záznamy'
        "
        sort-direction="desc"
        v-bind="$attrs"
        v-on="$listeners"
      >
        <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
          <slot v-bind="scope" :name="slot" />
        </template>
      </b-table>
      <div v-if="isBusy" class="loading">
        <div class="spinner-border" />
      </div>
    </div>
    <div class="d-flex align-items-center">
      <div>Celkom: {{ totalRows }} záznamov</div>
      <div class="d-flex ml-auto">
        <b-form-select
          v-model="perPage"
          size="sm"
          :current-page="currentPage"
          :options="pageOptions"
          class="mr-2"
        />
        <b-pagination
          v-model="currentPage"
          size="sm"
          :per-page="perPage"
          :total-rows="totalRows"
          class="my-0"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    tableClass: {
      type: String,
      default: '',
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    pageOptions: {
      type: Array,
      default() {
        return [10, 20, 50, 100]
      },
    },
    sortDesc: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isBusy: false,
      searchVal: null,
      searchIn: [],
      showFilter: false,
      totalRows: 0,
      currentPage: 1,
    }
  },
  mounted() {
    this.totalRows = this.data.length
  },
  methods: {
    refresh() {
      this.$refs.table.refresh()
    },
    search() {
      this.refresh()
    },
    applyFilter() {
      this.$emit('filterApply')
      this.refresh()
    },
    resetFilter() {
      this.$emit('filterReset')
      this.showFilter = false
    },
    toggleFilter() {
      if (this.showFilter) {
        this.showFilter = false
      } else {
        this.showFilter = true
      }
    },
  },
}
</script>
<style></style>
